import { ChakraProvider } from "@chakra-ui/react";
import Embed from "./components/Embed";
import { DataSourceProvider } from "./DataSource";
import { ErrorBoundary } from "react-error-boundary";
import ErrorView from "./components/ErrorView";
import { appTheme } from "./theme";
import ErrorViewWithSetup from "./components/ErrorViewWithSetup";

export default function App() {
  return (
    <ChakraProvider theme={appTheme}>
      <ErrorBoundary FallbackComponent={ErrorView}>
        <ErrorBoundary FallbackComponent={ErrorViewWithSetup}>
          <DataSourceProvider>
            <Embed />
          </DataSourceProvider>
        </ErrorBoundary>
      </ErrorBoundary>
    </ChakraProvider>
  );
}
